export enum ServiceSelectionEnum {
    SOLO = 'N',
    PRO = 'Y',
    GO = 'G',
    EXPRESS = 'E',
}

export const ServiceSelectionLabelMapping: Record<
    ServiceSelectionEnum,
    string
> = {
    [ServiceSelectionEnum.SOLO]: 'Solo',
    [ServiceSelectionEnum.PRO]: 'Pro',
    [ServiceSelectionEnum.GO]: 'Go',
    [ServiceSelectionEnum.EXPRESS]: 'Express',
};
